import {
    AutogenModelCarrierPayAdjustments, AutogenRowCarrierPayAdjustments
} from "./autogen/AutogenModelCarrierPayAdjustments";

export class ModelCarrierPayAdjustments extends AutogenModelCarrierPayAdjustments<RowCarrierPayAdjustments> {
    constructor() {
        super(RowCarrierPayAdjustments);
    }
}

export class RowCarrierPayAdjustments extends AutogenRowCarrierPayAdjustments {
}
